import PropTypes from "prop-types";

import convertToImgixUrl from "@/utils/convertToImgixUrl";
import { imageCss } from "../ProseMirrorImageBlock.style";

const propTypes = {
  currentImage: PropTypes.object,
};

const InlineImage = ({ currentImage }) => {
  const altText = currentImage?.alt_text;
  const imgixUrl = convertToImgixUrl(currentImage?.url);

  return <img src={imgixUrl} alt={altText} css={imageCss} />;
};

InlineImage.propTypes = propTypes;

export default InlineImage;
